"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_LIMITS = exports.apiKeyTypeId = exports.NetworkApplicationServerClassName = exports.SYSTEM = exports.SystemClassName = exports.Milliseconds = exports.DataLifeCyclePeriod = void 0;
var iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "DataLifeCyclePeriod", { enumerable: true, get: function () { return iotv_v3_types_1.DataLifeCyclePeriod; } });
Object.defineProperty(exports, "Milliseconds", { enumerable: true, get: function () { return iotv_v3_types_1.Milliseconds; } });
const projectCode = process.env.projectCode ?? process.env.REACT_APP_PROJECT_CODE;
const stage = process.env.stage ?? process.env.REACT_APP_DEPLOYMENT_STAGE;
const key = `${projectCode}-${stage}`;
exports.SystemClassName = 'System';
exports.SYSTEM = {
    type: exports.SystemClassName,
    name: 'System',
    id: `${key}`,
    pk: `${exports.SystemClassName}:${key}`,
    sk: `${exports.SystemClassName}:${key}`,
};
exports.NetworkApplicationServerClassName = 'LoRaWANApplicationServer';
exports.apiKeyTypeId = 'APIKey';
// AWS max limits in bytes
exports.AWS_LIMITS = {
    Lambda: {
        returnPayload: 6291556,
    },
    SQS: {
        message: 262144,
    },
};
